import React, { FC } from "react";
import "./InfoPopup.scss";
// 1) Change the interface so it accepts the same "MoreInfoData" shape
//    you use in Map.tsx. If it’s truly optional, mark it with '?'.
import { MoreInfoData } from "../../entities/MoreInfoData";
import { BrowserLanguage } from "../../entities/BrowserLanguage";
import { useEffect } from "react";

interface Station {
  id: string;
  mac: string;
  code: string;
  name: string;
  status: string;
  connectors: {
    standard: string;
    powerType: string;
    format: string;
    maxPower: number;
  }[];
}

interface InfoPopupProps {
  isOpen: boolean; // controls visibility of the popup
  onClose: () => void; // callback to change parent state
  moreInfoData?: MoreInfoData; // The actual “MoreInfoData” from v2
  children?: React.ReactNode; // optional extra content
  lang: BrowserLanguage;
  stations?: Station[];
}

const InfoPopup: FC<InfoPopupProps> = ({
  isOpen,
  onClose,
  moreInfoData,
  children,
  lang,
  stations,
}) => {
  
  
  if (!isOpen) return null;

  function getTextDir(): string {
    switch (lang) {
      case BrowserLanguage.en:
        return "ltr";
      case BrowserLanguage.ru:
        return "ltr";
      case BrowserLanguage.ar:
        return "rtl";
      case BrowserLanguage.he:
        return "rtl";
      default:
        return "rtl";
    }
  }

  function getInfoTitle(): string {
    switch (lang) {
      case BrowserLanguage.en:
        return "Information";
      case BrowserLanguage.ru:
        return "Дополнительная информация";
      case BrowserLanguage.ar:
        return "مزيد من المعلومات";
      case BrowserLanguage.he:
        return "מידע נוסף";
      default:
        return "";
    }
  }

  function getNoInfoText(): string {
    switch (lang) {
      case BrowserLanguage.en:
        return "Rate unknown";
      case BrowserLanguage.ru:
        return "Тариф неизвестен";
      case BrowserLanguage.ar:
        return "التعريفة غير معروفة";
      case BrowserLanguage.he:
        return "התעריף לא ידוע";
      default:
        return "";
    }
  }

  return (
    <div
      className="info-popup-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="info-popup-title"
    >
      <div className="info-popup-content">
        {/* "X" button to close */}
        <button
          className="info-popup-close"
          onClick={() => {
            onClose();
          }}
          tabIndex={20}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onClose();
            }
          }}
          aria-label="Close Popup"
          role="button"
        >
          X
        </button>

        <h1 id="info-popup-title">{getInfoTitle()}</h1>

        {/* Instead of Lorem, we use the actual data from "moreInfoData". */}
        {moreInfoData ? (
          <div dir={getTextDir()}>

            <p
              tabIndex={20}
              style={{
                whiteSpace: "break-spaces",
                overflowY: "auto",
                maxHeight: "400px",
              }}
            >
              {moreInfoData?.text?.replace(/.*tariff.*/gi, "") ?? "No Info"}
            </p>
          </div>
        ) : (
          <div tabIndex={20}>{getNoInfoText()}</div>
        )}

        {/* If there's any children passed in, render them */}
        {children}
      </div>
    </div>
  );
};

export default InfoPopup;
